module.exports = __webpack_public_path__ + "img/factory.63c80e18.svg";